import { render, staticRenderFns } from "./PortalRegister.vue?vue&type=template&id=60f6dd56&"
import script from "./PortalRegister.vue?vue&type=script&lang=js&"
export * from "./PortalRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports